import React, { useState } from "react";
import { Checkbox, Input } from "antd";

import remove_icon from "../../../../../images/icons/remove_icon.png";
import add_step from "../../../../../images/icons/add_step.png";
import AnswerImageCrop from "./AnswerImageCrop";

// Одна строка/карточка ответа конструктора теста, вид зависит от question.type.
// single/по умолчанию: карточка в сетке (см. .answers_list--cards в
// ChangeLessonParent.scss) - текст+чекбокс сверху (это единственное, что всегда
// обязательно - вопрос может быть чисто текстовым), картинка снизу как опциональное
// дополнение (2026-07-26: раньше картинка была сверху с чекбоксом поверх нее, но
// раз картинки может не быть вообще, чекбокс логичнее держать у текста).
// ordering/matching: компактная строка без картинки (откатили на этих двух типах).
const AnswerRow = (props) => {
    const {
        type, el, index, setCheckbox, setText, setPairItem, setImage, removeImage,
        removeAnswer, viewRemoveAnswerIcon, viewAddAnswerIcon, setAddAnswer, placeholder,
        imageRequired, showErrors,
    } = props;

    const [rawImage, setRawImage] = useState("");
    const [cropOpen, setCropOpen] = useState(false);

    const inputId = `quiz_img_input_${index}`;
    const thumbPreview = el.img_question_base64 || el.img_question;

    const closeCrop = () => {
        setCropOpen(false);
        setRawImage("");
        const input = document.getElementById(inputId);
        if (input) input.value = "";
    };

    const fileInput = (
        <input
            id={inputId}
            type="file"
            accept="image/*"
            style={{display: "none"}}
            onChange={(e) => {
                const file = e.target.files[0];
                if (!file) return;
                const reader = new FileReader();
                reader.onload = () => {
                    setRawImage(reader.result);
                    setCropOpen(true);
                };
                reader.readAsDataURL(file);
            }}
        />
    );

    const cropModal = (
        <AnswerImageCrop
            open={cropOpen}
            imageSrc={rawImage}
            onCancel={closeCrop}
            onSave={({thumbnail, full}) => {
                setImage(thumbnail, full);
                closeCrop();
            }}
        />
    );

    if (type === "single" || !type) {
        const imageMissing = imageRequired && !thumbPreview;
        const textError = showErrors && !el.text;
        const imageError = showErrors && imageMissing;
        let mediaClass = "answer_card_media";
        if (imageError) mediaClass += " has-error";
        else if (imageMissing) mediaClass += " required";
        return (
            <>
                <div className="answer_card">
                    <div className="answer_card_top">
                        <Checkbox
                            className="checkbox_antd"
                            checked={el.correct}
                            onClick={(e) => setCheckbox(e.target.checked)}
                        />
                        <Input.TextArea
                            value={el.text}
                            onChange={(e) => setText(e.target.value)}
                            className={textError ? "input_classic answer_card_text has-error" : "input_classic answer_card_text"}
                            placeholder={placeholder}
                            autoSize={{minRows: 1, maxRows: 3}}
                        />
                        {viewRemoveAnswerIcon &&
                            <img
                                className="answer_card_remove_answer"
                                onClick={() => removeAnswer(el.id)}
                                src={remove_icon}
                            />}
                    </div>
                    <div
                        className={mediaClass}
                        onClick={() => document.getElementById(inputId).click()}
                    >
                        {thumbPreview
                            ? <img className="answer_card_media_img" src={thumbPreview} alt={el.text || ""}/>
                            : <div className="answer_card_media_placeholder">
                                <span className="answer_card_media_plus">+</span>
                                <span>{imageMissing ? "Добавьте картинку" : "Добавить картинку"}</span>
                              </div>}
                        {thumbPreview &&
                            <div
                                className="answer_card_remove_image"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    removeImage();
                                }}
                            >
                                ×
                            </div>}
                    </div>
                    {fileInput}
                    {cropModal}
                </div>
                {viewAddAnswerIcon &&
                    <div onClick={setAddAnswer} className="answer_card answer_card--add">
                        <div className="answer_card_media answer_card_media--add">
                            <img src={add_step} alt=""/>
                        </div>
                        <div className="answer_card_add_label">Добавить вариант</div>
                    </div>}
            </>
        );
    }

    // ordering/matching - обычная текстовая строка, без картинки (2026-07-26:
    // картинку на этих двух типах откатили по просьбе пользователя, остаётся
    // только у "Один или несколько вариантов" выше).
    const textError = showErrors && !el.text;
    const pairError = showErrors && type === "matching" && !el.pair_item;
    return (
        <div className={"choice_parent"}>
            <div style={{margin: "0 5px", color: "white"}}>{index}</div>
            <div className="group" style={{display: "flex", gap: 8, alignItems: "center"}}>
                {type === "matching" &&
                    <Input
                        value={el.pair_item}
                        onChange={(e) => setPairItem(e.target.value)}
                        className={pairError ? "input_classic has-error" : "input_classic"}
                        size="large"
                        placeholder="Левая часть пары"
                    />}
                <Input
                    value={el.text}
                    onChange={(e) => setText(e.target.value)}
                    className={textError ? "input_classic has-error" : "input_classic"}
                    style={{paddingRight: 30}}
                    size="large"
                    placeholder={type === "matching" ? "Правая часть пары" : placeholder}
                />
                {viewRemoveAnswerIcon && <img onClick={() => removeAnswer(el.id)} src={remove_icon}/>}
            </div>
            {viewAddAnswerIcon &&
                <div onClick={setAddAnswer} className="add_answer"><img src={add_step}/></div>}
        </div>
    );
};

export default AnswerRow;
